import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  advancedFilterWorker,
  tableSkeleton
} from "../../../constant/helper/helper";
import ShowDateList from "./ShowDateList";
import { Link } from "react-router-dom";
import useSortableData from "../../../customHooks/sortingHooks";
import { tableHeaderData } from "./sheetStaticData";
import TableHeader from "../../../component/tableHeader/TableHeader";

const CanteenUserList = ({
  values,
  loading,
  loginType,
  dateArrayState,
  canteenSheetData,
  dateDifference
}) => {
  const onHeaderChange = (colSpan, headerType) => {
    return dateArrayState.map((dateRange, dateRangeIndex) => {
      return headerType === "first" ? (
        <th
          key={dateRangeIndex}
          className="text-center"
          colSpan={colSpan}
          rowSpan={"1"}
        >
          {dateRange}
        </th>
      ) : (
        <Fragment key={dateRangeIndex}>
          <th className="text-center" colSpan={colSpan} rowSpan={"1"}>
            B
          </th>
          <th className="text-center" colSpan={colSpan} rowSpan={"1"}>
            L
          </th>
          <th className="text-center" colSpan={colSpan} rowSpan={"1"}>
            D
          </th>
        </Fragment>
      );
    });
  };
  const showUserList = (sheetData) => {
    if (loading) {
      return (
        <tr>{tableSkeleton(12 + Number(dateDifference) * 3)}</tr>
      );
    } else if (
      typeof sheetData !== "undefined" &&
      sheetData !== null &&
      sheetData.length > 0
    ) {
      const filterEmployees = advancedFilterWorker(
        sheetData,
        values.Filter,
        "fullNameAndId"
      );
      return filterEmployees.map((mapData, parentIndex) => {
        // const sortedDateList = sortDateAscendingOrder(mapData);
        return (
          <tr key={parentIndex} style={{ fontSize: 12 }}>
            <td>{parentIndex + 1}</td>
            <td style={{ fontSize: 12 }}>{mapData.workerId}</td>
            <td className="table-user">
              <span className="text-body font-weight-semibold">
                <Link to={`/hr/user/all-users/${mapData.employeeId}`}>
                  {mapData.workerFullName}
                </Link>
              </span>
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDepartment}
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDesignation}
            </td>
            <td className="text-center" style={{ fontSize: 12 }}>
              {mapData.Location}
            </td>

            <ShowDateList
              dayList={mapData.dailyPointsArray}
              values={values}
            />

            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalBreakFast)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalLunch)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.TotalDinner)}
              </span>
            </td>
          </tr>
        );
      });
    } else if (sheetData === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              Please Select From Date, To Date and Location
            </span>
          </td>
        </tr>
      );
    } else if (sheetData.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  const { items, requestSort, sortConfig } = useSortableData(
    canteenSheetData
  );

  return (
    <div
      className="table-responsive"
      style={{ height: "700px", overflow: "auto" }}
    >
      <table
        className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
        id="products-datatable"
      >
        <thead className="thead-light">
          <tr>
            <th style={{ width: "20px" }} rowSpan={"2"}>
              #
            </th>
            <TableHeader
              tableHeaderData={tableHeaderData}
              requestSort={requestSort}
              sortConfig={sortConfig}
              rowSpan={"2"}
            />

            {onHeaderChange(3, "first")}
            <th className="text-center" colSpan={3} rowSpan={"1"}>
              Total DIETS
            </th>
          </tr>
          <tr>
            {onHeaderChange(1, "second")}
            <th className="text-center">B</th>
            <th className="text-center">L</th>
            <th className="text-center">D</th>
          </tr>
        </thead>
        <tbody>{showUserList(items)}</tbody>
      </table>
    </div>
  );
};

CanteenUserList.propTypes = {
  loading: PropTypes.bool,
  values: PropTypes.object.isRequired,
  canteenSheetData: PropTypes.array,
  loginType: PropTypes.string.isRequired,
  dateArrayState: PropTypes.array.isRequired,
  dateDifference: PropTypes.number.isRequired
};

export default CanteenUserList;
